export const TaxAdvisorUrls = {
  CLIENTS_COMPANIES: "/tax-advisor/client-entities",
  THIRD_PARTY_TAX_ADVISORS_CUSTOMERS: "/tax-advisor/third-party-tax-advisors-customers",
  FORMER_CLIENTS: "/tax-advisor/former-clients",
  FORMER_THIRD_PARTY_CLIENTS: "/tax-advisor/former-third-party-clients"
};
